import { Link } from 'react-router-dom'
import { EyeIcon } from '@components/Icons'
import { ColumnType } from '@components/Table/interface'
import { TopWriterType } from '@models/salse/TopWriterType'

export const columns: ColumnType<TopWriterType>[] = [
  {
    column: 'อันดับ',
    accessor: 'numRow',
    cell: ({ value }) => <p>{value || '-'}</p>,
    isSortable: true,
    sortKey: 'rowNumber',
    cellClassName: 'w-[180px] max-w-[180px] py-[7px]',
  },
  {
    column: 'User ID',
    accessor: 'id',
    cell: ({ value }) => <p>{value || '-'}</p>,
    isSortable: true,
    sortKey: 'usersId',
    cellClassName: 'w-[250px] max-w-[250px] py-[7px]',
  },
  {
    column: 'Username',
    accessor: 'username',
    cell: ({ value }) => <p>@{value}</p>,
    isSortable: true,
    sortKey: 'userUsername',
    cellClassName: 'py-[7px]',
  },
  {
    column: 'Sales',
    accessor: 'totalIncome',
    cell: ({ value }) => <p>{value.toLocaleString()} เหรียญ</p>,
    isSortable: true,
    sortKey: 'userTotalIncome',
    cellClassName: 'w-[350px] max-w-[350px] py-[7px]',
  },
  {
    column: 'Action',
    accessor: 'username',
    cell: ({ obj }) => (
      <Link
        to={{
          pathname: '/dashboard/writer-publisher',
          search: `?tab=byUser&userId=${obj.id}&writerId=${obj.writerId}`,
        }}
        target='_blank'
      >
        <button
          className='border border-gray bg-white h-[30px] px-[4px] rounded-[8px]'
          type='button'
        >
          <EyeIcon className='text-black-970' width='18' height='18' />
        </button>
      </Link>
    ),
    isSortable: false,
    cellClassName: 'w-[45px] max-w-[45px] py-[7px]',
  },
]
